// import components from './components';
import * as components from './components';

document.addEventListener('DOMContentLoaded', () => {
  // loop each registered component
  const componentNames = Object.keys(components);

  componentNames.forEach(componentName => {
    // get nodes by defined selector
    const component = components[componentName];
    const nodesToInstantiate = [...document.querySelectorAll(component.selectorString())];

    // instantiate the js class for each node
    nodesToInstantiate.forEach(node => {
      const props = node.getAttribute('data-props');

      new component(node, JSON.parse(props));
    });
  });
});
